import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmdpzxxk96: FaireProductEntity = {
  token: "p_fmdpzxxk96",
  type: "product",
  name: "Jesus Vibes Boho Tee",
  brandToken: "b_d849rxmheb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/caa919655acb5d160a9abafcc6a97d04e70f3c4be56326006b04ae4485f5cd2a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bcd971dd8640df1c2962ebe2f4226a5e096cf4d0a54fdb9a6df5633f7da4fdc.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "This retro-inspired faith design brings laid-back style and meaning together in the best way. Featuring bold, vintage-style lettering layered over soft, muted tones, the message feels uplifting without being loud or overdone. It’s the kind of design that speaks quietly but confidently—easy to wear, easy to love.\nPerfect for everyday errands, casual gatherings, or Sunday plans, this piece pairs effortlessly with denim and layers beautifully through every season. A go-to option for those who love faith-based designs with a modern, trend-forward feel.\nCC1717 Bay or Espresso\n6.1 oz./yd² (US), 10 oz/L yd (CA), 100% ring-spun cotton, 30 singles\nGarment-dyed for that lived in feel and almost no shrinkage at home.\nSoft ring-spun cotton fabric with 100% cotton threads\nRelaxed fit\nTopstitched, classic width, rib collar\nShoulder to shoulder twill tape\nSignature twill label",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:37.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
